import { Component,Injectable, Input } from "@angular/core";
import { NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import {  Router } from "@angular/router";

/**
 * @version $Id: content.component.ts 79096 2018-02-14 19:42:35Z thiago.h.neri $
 */
@Component({
  selector: "modaltimeuut",
  templateUrl:"./content.template.html"
})
@Injectable()
export class ModalTimeOut {
  
  
  
  constructor(
    private router: Router,private activeModal: NgbActiveModal
  ) {}

  public logout(){
    localStorage.setItem("ALREADY_OPEN", "false");
    this.redirect("/Portal/data/login");
  }

  private close() {
    this.activeModal.dismiss();
  }

  public redirect(andress: string) {
    this.router.navigate([andress], { queryParams: { filter: false } });
    this.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/modaltimeout/content.component.ts